/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Settings_Forbidden_TitleInputs */

const vi_invoice_settings_forbidden_title = /** @type {(inputs: Invoice_Settings_Forbidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem cấu hình hóa đơn`)
};

/**

* @param {Invoice_Settings_Forbidden_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_settings_forbidden_title = /** @type {((inputs?: Invoice_Settings_Forbidden_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Settings_Forbidden_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_settings_forbidden_title(inputs)
});